import { render, staticRenderFns } from "./RoleCreateOrUpdate.vue?vue&type=template&id=3c466fa9&scoped=true"
import script from "./RoleCreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./RoleCreateOrUpdate.vue?vue&type=script&lang=js"
import style0 from "./RoleCreateOrUpdate.vue?vue&type=style&index=0&id=3c466fa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c466fa9",
  null
  
)

export default component.exports